<template>
    <div class="HousingManagement">
      <el-form class="select" label-width="100px">
        <el-form-item label="字段名称:">
          <el-input placeholder="请输入字段名称" v-model="requestParameters.dictValue" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="字典类型:"> -->
          <!-- <el-input placeholder="请输入字段类型" v-model="requestParameters.dictType" clearable></el-input> -->
          <!-- <el-select placeholder="请选择字典类型" v-model="requestParameters.dictType" style="width: 100%" clearable filterable>
              <el-option   v-for="item in dictTypelist"  :key="item.value"  :value="item.text" :label="item.text"></el-option>
          </el-select> -->
        <!-- </el-form-item> -->
        <el-form-item label="生效状态:">
          <!-- <el-input placeholder="请输入生效状态" v-model="requestParameters.isEffective" clearable></el-input> -->
            <el-select placeholder="请选择生效状态" v-model="requestParameters.isEffective " style="width: 100%" clearable filterable>
              <el-option   v-for="item in isEffectiveList"  :key="item.value"  :value="item.value" :label="item.text"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加人:">
          <!-- <el-input placeholder="请输入添加人" v-model="requestParameters.createId" clearable></el-input> -->
          <el-select placeholder="请选择提交人" v-model="requestParameters.createId" style="width: 100%" clearable filterable>
              <el-option   v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
          </el-select>
        </el-form-item>
          <el-form-item label="字典编码:">
          <el-select placeholder="请选择字典编码" v-model="requestParameters.dictCode" style="width: 100%" clearable filterable>
              <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.dictCode" :label="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="添加时间:">
            <el-date-picker v-model="requestParametersTimer" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clear" class="btns" size="small" icon="el-icon-close">清除</el-button>
          <el-button type="primary" @click="searchBtn"  size="small" class="btns" icon="el-icon-search">搜索</el-button>
          <el-button type="primary" @click="addDiction"  size="small" class="btns" icon="el-icon-plus">添加字段</el-button>
        </el-form-item>
      </el-form>
      <!-- table表格 -->
      <el-table :header-cell-style="{
        background: '#fafafa',
      }" :data="dataList" border>
        <!-- <el-table-column prop="teacherName" label="租住教师">
        </el-table-column> -->
        <el-table-column prop="dictValue" label="字典名称" >
        </el-table-column>
        <el-table-column prop="dictCode" label="字典编码">
        </el-table-column>
        <!-- <el-table-column prop="dictType" label="字典类型"> -->
        <!-- <template slot-scope="scope">
          <p>{{ scope.row.dictType === 1? '签约公司' : '所在地域' }}</p>
        </template> -->
        <!-- </el-table-column> -->
        <el-table-column prop="isEffective" label="是否生效">
        <template slot-scope="scope">
          <p>{{ scope.row.isEffective === 0? '正常' : '停用' }}</p>
        </template>
        </el-table-column>
        <el-table-column prop="createName" label="添加人">
        </el-table-column>
        <el-table-column prop="createTime" label="添加时间">
        </el-table-column>
        <el-table-column header-align="center" width="150" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="addDiction('edit',scope.row)">编辑</el-button>
        </template>
      </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="requestParameters.pageNo" :page-size="requestParameters.pageSize"
        layout="prev, pager, next,sizes, jumper" :total="total">
      </el-pagination>

  <!-- 添加字段 -->
      <el-dialog :title="isFlag ? '添加字段' : '编辑字段'" :visible.sync="isShowTeacher" :close-on-click-modal = false>
        <el-form label-width="120px">
          <el-form-item label="字典名称:" style="width: 100%; text-align: left;">
            <el-input v-model="addObj.dictValue" placeholder="请输入字典名称" autocomplete="off"
              @keyup.enter.native="changeRoom"></el-input>
          </el-form-item>
          <!-- <el-form-item label="字典类型:" style="width: 100%; text-align: left;" >
            <el-input placeholder="请输入字段类型" v-model="addObj.dictType" clearable></el-input>
          </el-form-item> -->
          <el-form-item label="字典编码:" style="width: 100%; text-align: left;" >
            <!-- <el-input v-model="addObj.dictCode" placeholder="请输入字典编码" autocomplete="off"></el-input> -->
            <el-select placeholder="请选择字典编码" v-model="addObj.dictCode" style="width: 100%" clearable filterable>
              <el-option   v-for="item in optionList1"  :key="item.id"  :value="item.dictCode" :label="item.dictCode"></el-option>
          </el-select>
          </el-form-item>
          <el-form-item label="生效状态:" style="width: 100%; text-align: left;" >
            <el-select placeholder="请选择生效状态" v-model="addObj.isEffective " style="width: 100%" clearable filterable>
              <el-option   v-for="item in isEffectiveList"  :key="item.value"  :value="item.value" :label="item.text"></el-option>
          </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="isShowTeacherfalse">取 消</el-button>
          <el-button type="primary" @click="addsRoomInfo">确 定</el-button>
        </div>
      </el-dialog>
  
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  export default {
    data () {
      return {
        isFlag:true,
        isShowTeacher:false,
        dialogFormVisible: false,
        total: 0,
        contactPerson: "",//对接人
        deposit: "",//押金
        rent: '',//租金
        roomEndTime: "",//房屋到期时间
        roomNumber: "",//房间号
        roomStartTime: "",//房屋租赁时间teacherInTime
        teacherInTime: "",//入住时间
        teacherName: "",//教师姓名
        dataList: [],
        editObj: {//编辑
          contactPerson: "",//对接人
          deposit: "",//押金
          rent: '',//租金
          roomEndTime: "",//房屋到期时间
          roomNumber: "",//房间号
          roomStartTime: "",//房屋租赁时间
          teacherInTime: "",//入住时间
          teacherName: "",//教师姓名
          contactPersonPhone: "",//对接人联系方式
          teachPhone: '',//教师联系方式
        },
        addObj: {//添加
          id:'',
          dictValue: '',
          dictType: '',
          dictCode: '',
          isEffective: ''
        },
        addObj1: {
          contactPerson: "",//对接人
          deposit: "",//押金
          rent: '',//租金
          roomEndTime: "",//房屋到期时间
          roomStartTime: "",//房屋租赁时间
          contactPersonPhone: "",//对接人联系方式
        },
        requestParameters: {
          pageSize: 10,
          pageNo: 1, 
          dictValue: '',
          dictType: null,
          dictCode: '',
          createId: '',
          isEffective:'',
        },
        requestParametersTimer: [],
        optionList1:[],
        optionList2: [],
        dictTypelist: [
          {text:'签约公司', value:1},
          {text:'所在地域', value:2},
        ],
        isEffectiveList: [
          {text:'正常', value:0},
          {text:'停用', value:1},
        ]
      }
    },
    created () {
      this.getList()
      axios.get(`${ apiBaseUrl }/questionnaire/queryCreator`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res)=>{ this.optionList2 = res.data.data })
      axios.get(`${ apiBaseUrl }/dict/getDictCode`, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res)=>{ this.optionList1 = res.data.data  })
      
      
      
      
    },
    methods: {

      addsRoomInfo() {
        if (this.isFlag) {
          let obj = {
          dictValue: this.addObj.dictValue,
          // dictType: this.addObj.dictType,
          dictCode: this.addObj.dictCode,
          isEffective: this.addObj.isEffective,   
        }
        axios
          .post(`${apiBaseUrl}/dict/addDict`, obj,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }) // 请替换为你的API URL
          .then(res => {
            
          if (res.data.code === 200) {
            this.getList()
            this.$message({type: 'success', message: '添加成功~'})
          } else {
            this.$message({ message: res.message,   type: "error"})
            }
            this.addObj = {
              dictValue: '',
              dictType: '',
              dictCode: '',
              isEffective: ''
            },
            this.isShowTeacher = false
            this.getList()
          })
          .catch(error => {
            console.error(error);
          });
        } else {
          let obj = {
          id:this.addObj.id,
          dictValue: this.addObj.dictValue,
          // dictType: this.addObj.dictType,
          dictCode: this.addObj.dictCode,
          isEffective: this.addObj.isEffective,   
        }
        axios
          .put(`${apiBaseUrl}/dict/editDict`, obj,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }) // 请替换为你的API URL
          .then(res => {
            
          if (res.data.code === 200) {
            this.getList()
            this.$message({type: 'success', message: '修改成功~'})
          } else {
            this.$message({ message: res.message,   type: "error"})
            }
            this.addObj = {
              dictValue: '',
              dictType: '',
              dictCode: '',
              isEffective: ''
            },
            this.isShowTeacher = false
            this.getList()
          })
          .catch(error => {
            console.error(error);
          });
        }

        this.getList()
        this.isShow = false
      },
      //添加按钮
      addDiction(tepy, row) {
        
        if (tepy === 'edit') {
          this.isFlag = false
          this.isShowTeacher = true

          this.addObj.id = row.id
          this.addObj.dictValue = row.dictValue
          // this.addObj.dictType = row.dictType
          this.addObj.dictCode = row.dictCode
          this.addObj.isEffective = row.isEffective
        } else {
          this.isFlag = true
          this.isShowTeacher = true

          
          
        }
      },
      //根据房间号查询
      changeRoom () {
        let data = {
          roomNumber: this.addObj.roomNumber
        }
        axios
          .post(`${apiBaseUrl}/room/list`, data,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }) // 请替换为你的API URL
          .then((res) => {
            if (res.data.data.list.length > 0) {
              this.addObj1.roomStartTime = res.data.data.list[0].roomStartTime
              this.addObj1.roomEndTime = res.data.data.list[0].roomEndTime
              this.addObj1.deposit = res.data.data.list[0].deposit
              this.addObj1.rent = res.data.data.list[0].rent
              this.addObj1.contactPerson = res.data.data.list[0].contactPerson
              this.addObj1.contactPersonPhone = res.data.data.list[0].contactPersonPhone
            }
          })
          .catch((error) => {
            console.error(error);
          });
      },
      handleSizeChange (pageSize) {
        this.requestParameters.pageSize = pageSize;
        this.getList();
      },
      // 进入某一页
      handleCurrentChange (newPage) {
        this.requestParameters.pageNo = newPage;
        this.getList();
      },
      //获取表格数据
      getList () {
        let data = {
          isEffective:this.requestParameters.isEffective,
          pageNo: this.requestParameters.pageNo,
          pageSize: this.requestParameters.pageSize,
          dictValue: this.requestParameters.dictValue,
          dictType: this.requestParameters.dictType,
          dictCode: this.requestParameters.dictCode,
          createId: this.requestParameters.createId,
          insertStartTime: this.requestParametersTimer[0],
          insertEndTime: this.requestParametersTimer[1],
          
        }
        axios.post(`${apiBaseUrl}/dict/getDictList`, data,{
          headers:{
          'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
            
            this.total = res.data.data.total
            this.dataList = res.data.data.records
          }).catch((error) => {
            
            console.error(error);
          })
      },
 
      //清除
      clear () {
        this.requestParameters = {
          pageSize: 10,
          pageNo: 1, 
          dictValue: '',
          dictType: null,
          dictCode: '',
          createId: '',
        },
        this.requestParametersTimer = [],
        this.getList()
      },
      //搜索
      searchBtn () {
        this.requestParameters.pageNo = 1
        this.getList()

      },
      isShowTeacherfalse() {
        this.addObj = {
          dictValue: '',
          dictType: '',
          dictCode: '',
          isEffective: ''
        },
        this.isShowTeacher = false
      }
    }
  }
  </script>
  
  <style scope>
  .select {
    display: flex;
    flex-wrap: wrap;
  }
  
  @media screen and (max-width: 750px) {
    .HousingManagement {
      /* overflow: auto; */
      width: 1430px;
    }
  
    /* 兼容移动端 */
    #aa>>>.HousingManagement {
      width: 70% !important;
    }
  }
  .btns{
    background-color: #428BCA;
    border-color: #428BCA;
    color: #fff;
  }
  </style>
  


// WEBPACK FOOTER //
// src/dictionaryManaged/dictionaryManaged.vue